import { render, staticRenderFns } from "./SendEmailInvoiceDialog.vue?vue&type=template&id=ec38c57a&scoped=true"
import script from "./SendEmailInvoiceDialog.vue?vue&type=script&lang=js"
export * from "./SendEmailInvoiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38c57a",
  null
  
)

export default component.exports